// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentResultModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentResultModelResponse.attributeTypeMap;
    }
}
EnrollmentResultModelResponse.discriminator = undefined;
EnrollmentResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentResultModel"
    }
];
//# sourceMappingURL=enrollmentResultModelResponse.js.map